import React from 'react';
import {
  DevicePhoneMobileIcon,
  ArrowTopRightOnSquareIcon
} from '@heroicons/react/24/outline';

function AppDownloadShortcutCard() {
  return (
    <div className="group relative overflow-hidden rounded-2xl border border-fuchsia-200 bg-gradient-to-br from-fuchsia-50 via-white to-indigo-50 shadow-sm transition-all duration-300 hover:shadow-lg hover:border-fuchsia-300">
      <div className="relative p-5 sm:p-6">
        <div className="mb-3 flex items-center justify-between">
          <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-fuchsia-500 to-indigo-600 text-white shadow-md">
            <DevicePhoneMobileIcon className="h-6 w-6" />
          </div>
        </div>
        <p className="text-xs font-semibold uppercase tracking-[0.14em] text-fuchsia-700">
          Mobile app
        </p>
        <h3 className="mt-2 text-xl font-bold text-slate-900">Get the app</h3>
        <p className="mt-2 text-sm leading-6 text-slate-600">
          Open the smart download page for quick access to the iPhone and Android install links.
        </p>
        <a
          href="/download"
          target="_blank"
          rel="noreferrer"
          className="mt-4 inline-flex items-center gap-2 rounded-xl bg-slate-900 px-4 py-2.5 text-sm font-semibold text-white transition-transform duration-200 hover:-translate-y-0.5"
        >
          Open download page
          <ArrowTopRightOnSquareIcon className="h-4 w-4" />
        </a>
      </div>
    </div>
  );
}

export default AppDownloadShortcutCard;
